import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../api.service';
import { RequestHandlerParams } from '../types/api-service.types';
import { ApiResponse } from '../common/types';

@Injectable({
  providedIn: 'root'
})
export class DonationService {
  private apiService = inject(ApiService);

  endpoints = {
    contribute: '/donations/contribute'
  };

  /**
   * Make a voluntary donation
   * @param amount - The donation amount
   * @returns Observable with the API response
   */
  contribute(amount: number): Observable<ApiResponse<any>> {
    const params: RequestHandlerParams = {
      endpoint: this.endpoints.contribute,
      method: 'POST',
      body: { amount },
      apiV3: true
    };

    return this.apiService.handleRequest<ApiResponse<any>>(params);
  }
}

